<template>
  <transition name="appear">
    <div class="gantt-filters" v-if="open">
      <div class="filters__header">
        <h3 class="title">Filtros</h3>
      </div>
      <div class="filters">
        <div class="select-area">
          <p class="label-text">Maquinas:</p>
          <VueSelect multiple :options="['J121', 'B903', 'G212', 'F390']">
            <div slot="no-options">Não há maquinas</div>
          </VueSelect>
        </div>
        <div class="select-area">
          <p class="label-text">Grupo:</p>
          <VueSelect :options="['grupo-1', 'grupo-2', 'groupo-3']">
            <div slot="no-options">Não há grupos</div>
          </VueSelect>
        </div>
      </div>
      <FilterBtn>Aplicar</FilterBtn>
      <FilterBtn cancel>Cancelar</FilterBtn>
    </div>
  </transition>
</template>

<script>
import { VueSelect } from "vue-select";
import FilterBtn from "./FilterBtn";

export default {
  name: "GanttFilters",
  components: {
    VueSelect,
    FilterBtn
  },
  props: {
    open: {
      type: Boolean,
      required: true
    }
  },
  methods: {}
};
</script>

<style>
.gantt-filters {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  background: var(--color-white);
  width: 100%;
  padding: 0 1rem;
  border-bottom: 1px solid var(--color-grey);
  height: 12.1rem;
}

.filters__header {
  height: 2.2rem;
  display: flex;
  position: relative;
  top: -0.6em;
}

.filters {
  max-width: 60rem;
  display: flex;
  align-items: center;
  margin-bottom: 1.4rem;
}

.label-text {
  margin-bottom: 0.4rem;
}

.select-area {
  flex: 1;
  margin-right: 1rem;
}
.gantt-filters .vs__dropdown-toggle {
  background-color: var(--color-white);
  border: none;
  box-shadow: 0 0 0 1px #42a5f5;
}
.gantt-filters .vs__dropdown-toggle:focus-within {
  box-shadow: 0 0 1px 2px #42a5f5 !important;
}
</style>